/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAlignBoxRightStretch = createReactComponent(
  "align-box-right-stretch",
  "IconAlignBoxRightStretch",
  [
    ["path", { d: "M15 17h2", key: "svg-0" }],
    [
      "path",
      {
        d: "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z",
        key: "svg-1"
      }
    ],
    ["path", { d: "M11 12h6", key: "svg-2" }],
    ["path", { d: "M13 7h4", key: "svg-3" }]
  ]
);

export { IconAlignBoxRightStretch as default };
//# sourceMappingURL=IconAlignBoxRightStretch.js.map
